import { render, staticRenderFns } from "./UiListboxOption.vue?vue&type=template&id=455fbe08&"
import script from "./UiListboxOption.vue?vue&type=script&lang=js&"
export * from "./UiListboxOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports